import { Component, EventEmitter, Input, Output } from '@angular/core';
import { postExportSettings } from '../../../../redux/mydoc.action';
import { Store } from '@ngrx/store';
import { storedSession } from '../../../../redux/mydoc.selector';
import { ISession } from '../../../../models/session/session.models';
import { SubscriptionComponent } from 'src/app/shared/subscription/subscription.component';
import { getValue } from '../../../../shared/utility/verify.lib';

@Component({
  selector: 'app-tooltip-overlay',
  templateUrl: './tooltip-overlay.component.html',
  styleUrl: './tooltip-overlay.component.scss',
})
export class TooltipOverlayComponent extends SubscriptionComponent {
  @Input() public toogleHeight: number = 0;
  @Output() public closeHandler: EventEmitter<void> = new EventEmitter<void>();

  public storedSession$ = this.store.select(storedSession);

  public constructor(private store: Store) {
    super();
  }

  public close(): void {
    const currentSession: ISession = this.getLatestValueFromSubscription(
      this.storedSession$
    );
    this.store.dispatch(
      postExportSettings({
        sessionId: getValue(() => currentSession.id),
        orderCode: getValue(() => currentSession.orderNumber),
      })
    );
    this.closeHandler.emit();
  }
}
